// extracted by mini-css-extract-plugin
var _1 = "active-media-preview";
var _2 = "base-link";
var _3 = "#000000";
var _4 = "#76F366";
var _5 = "#EB8632";
var _6 = "#ECC834";
var _7 = "#21FC87";
var _8 = "#EA4A30";
var _9 = "#C7EA45";
var _a = "#272B2B";
var _b = "#BDBDBD";
var _c = "#7D7D7D";
var _d = "#6A0DAD";
var _e = "#3A65FF";
var _f = "#4A90E2";
var _10 = "#ffffff";
var _11 = "fullHeight";
var _12 = "layout";
var _13 = "layoutOneColumn";
var _14 = "layoutStrictHeight";
var _15 = "layoutTwoColumn";
var _16 = "layoutWithSidebar";
var _17 = "layoutWithoutSidebar";
var _18 = "reset-button";
var _19 = "1200px";
var _1a = "992px";
var _1b = "1366px";
var _1c = "768px";
var _1d = "1475px";
var _1e = "576px";
var _1f = "1600px";
var _20 = "320px";
var _21 = "2500px";
var _22 = "single-page-responsive-font-size";
export { _1 as "active-media-preview", _2 as "base-link", _3 as "colorBlack", _4 as "colorGradeEX", _5 as "colorGradeFR", _6 as "colorGradeGD", _7 as "colorGradeOU", _8 as "colorGradePR", _9 as "colorGradeVG", _a as "colorNeutral", _b as "colorNeutralLighest", _c as "colorNeutralLight", _d as "colorNonOwnerSweetLine", _e as "colorOwnerSweetLine", _f as "colorRegularLinks", _10 as "colorWhite", _11 as "fullHeight", _12 as "layout", _13 as "layoutOneColumn", _14 as "layoutStrictHeight", _15 as "layoutTwoColumn", _16 as "layoutWithSidebar", _17 as "layoutWithoutSidebar", _18 as "reset-button", _19 as "screenlg", _1a as "screenmd", _1b as "screenml", _1c as "screensm", _1d as "screenxlg", _1e as "screenxs", _1f as "screenxxlg", _20 as "screenxxs", _21 as "screenxxxlg", _22 as "single-page-responsive-font-size" }
export default { "active-media-preview": _1, "base-link": _2, "colorBlack": _3, "colorGradeEX": _4, "colorGradeFR": _5, "colorGradeGD": _6, "colorGradeOU": _7, "colorGradePR": _8, "colorGradeVG": _9, "colorNeutral": _a, "colorNeutralLighest": _b, "colorNeutralLight": _c, "colorNonOwnerSweetLine": _d, "colorOwnerSweetLine": _e, "colorRegularLinks": _f, "colorWhite": _10, "fullHeight": _11, "layout": _12, "layoutOneColumn": _13, "layoutStrictHeight": _14, "layoutTwoColumn": _15, "layoutWithSidebar": _16, "layoutWithoutSidebar": _17, "reset-button": _18, "screenlg": _19, "screenmd": _1a, "screenml": _1b, "screensm": _1c, "screenxlg": _1d, "screenxs": _1e, "screenxxlg": _1f, "screenxxs": _20, "screenxxxlg": _21, "single-page-responsive-font-size": _22 }
